import { render, staticRenderFns } from "./AccountOrderDetailsSummary.vue?vue&type=template&id=6f0c2c68&"
import script from "./AccountOrderDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports